import React from "react";
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import {TransitionGroup} from 'react-transition-group';
import {Box} from "@mui/system";

function RenderItem({item, subtitle, handleRemove}) {
    return (
        <ListItem
            secondaryAction={
                <IconButton
                    edge="end"
                    aria-label="delete"
                    title="Delete"
                    onClick={() => handleRemove(item)}
                >
                    <DeleteIcon/>
                </IconButton>
            }
        >
            <ListItemText

                primary={item}
                primaryTypographyProps={{
                    style: {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }
                }}
                secondary={subtitle}
            />
        </ListItem>
    );
}

export default function AnimatedDoubleList({
    items = [],
    subtitles = [],
    removeListItem,
}) {

    return (
        <div>
            <Box sx={{mt: 1}}>
                <List>
                    <TransitionGroup>
                        {items.map((item, index) => (
                            <Collapse key={index}>
                                <RenderItem
                                    item={item}
                                    subtitle={subtitles[index]}
                                    handleRemove={removeListItem}
                                />
                            </Collapse>
                        ))}
                    </TransitionGroup>
                </List>
            </Box>
        </div>
    );
}
